var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-data-panel l-rblock"},[_c('div',{staticClass:"l-data-panel--title"},[_c('span',{staticClass:"l-data-panel--label"},[_vm._v(_vm._s(_vm.label))])]),_c('div',{staticClass:"l-rblock"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }